import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { useEffect, useRef } from "react";
import { useAnimations } from "@react-three/drei";
import { useFrame } from "react-three-fiber";

const Item = ({ animation, setAnimations, collection, token_id, setNotAO }) => {
  const group = useRef();

  const { asset, animations, scene, nodes, materials } = useLoader(
    GLTFLoader,
    "https://endpoint-gjc6u42x5a-uc.a.run.app/api/get_token/" + token_id
  );
  // console.log(scene);
  const { actions, names } = useAnimations(animations, group);
  useEffect(() => {
    // console.log(actions);

    if (actions[animation]) {
      for (const animation of names) {
        actions[animation].stop();
      }
      actions[animation].play();
    }
  }, [animation]);

  useEffect(() => {
    setAnimations(names);
  }, []);
  useEffect(() => {
    if (scene && nodes) {
      Object.entries(nodes).forEach(([key, value]) => {
        if (value.frustumCulled) {
          value.frustumCulled = false;
        }
      });

      scene.frustumCulled = false;
      group.current.frustumCulled = false;
    }
  }, [scene]);

  // function that creates a value from 0 to 1 that oscillates over time that simulates the shappe of a heart beat. This is used to animate the heart beat of the avatar. The value is used to scale the heart emissivity up and down.
  function heartBeat(time, offset) {
    var number = Math.sin(time * 3.5 + offset) * 0.5 + 0.75;
    return number < 0 ? 0 : number;
  }

  useFrame((state) => {
    if (materials) {
      // console.log(state.clock.getElapsedTime());
      Object.keys(materials).forEach((material) => {
        if (materials[material].name === "Material.001") {
          materials[material].emissiveIntensity =
            5 * heartBeat(state.clock.getElapsedTime(), 1);
        } else if (
          materials[material].name === "Material.001" ||
          materials[material].name === "Material.002" ||
          materials[material].name === "Material.004" ||
          materials[material].name === "Material.005" ||
          materials[material].name === "Material.006"
        ) {
          // console.log(materials[material].name);
          // materials[material].emissive = new THREE.Color(0x000000);
          materials[material].emissiveIntensity =
            20 * heartBeat(state.clock.getElapsedTime(), 1.2);
          // console.log(heartBeat(state.clock.getElapsedTime(), 3, 1.2));
        }
      });
    }
  });

  useEffect(() => {
    if (materials) {
      Object.keys(materials).forEach((material) => {
        // console.log(materials[material]);

        if (
          materials[material].name === "Material.002" ||
          materials[material].name === "Material.003" ||
          materials[material].name === "Material.004" ||
          materials[material].name === "Material.005" ||
          materials[material].name === "Material.006"
        ) {
          materials[material].emissiveIntensity = 20;
          materials[material].toneMapped = false;
        } else if (
          materials[material].name === "Material.001" ||
          materials[material].name === "Mat_DigiMask"
        ) {
          materials[material].emissiveIntensity = 5;
          materials[material].toneMapped = false;
        }
        if (materials[material].aoMap != null) {
          setNotAO(false);
        }
      });
    }
  }, [asset]);

  return (
    <group ref={group} dispose={null}>
      <primitive scale={1} object={scene} />
    </group>
  );
};
export default Item;
